import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { LayoutDashboard, Eye, Search, Rocket, Zap, Mail, Settings, LogOut, Sparkles } from 'lucide-react';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={s.app}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600;700&family=Nunito:wght@400;600;700;800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        body{background:#F6F8FA; color: #222}
        .nav-link{display:flex;align-items:center;gap:12px;padding:12px 20px;color:#444;font-family:'Fredoka',sans-serif;font-size:15px;font-weight:600;text-decoration:none;transition:all 0.15s;border: 2px solid transparent; border-radius: 12px; margin: 0 10px 8px 10px;}
        .nav-link:hover{color:#222;background:#FFF;border-color:#222;box-shadow: 2px 2px 0px #222;transform: translate(-1px, -1px);}
        .nav-link.active{color:#222;background:#FFD166;border-color:#222;box-shadow: 3px 3px 0px #222;transform: translate(-2px, -2px);}
        .nav-link.active .nem{color: #FF5C5C;}
        input:focus,textarea:focus{border-color:#222!important;box-shadow: 4px 4px 0px #FFD166!important;outline:none}
        select:focus{border-color:#222!important;outline:none}
        ::-webkit-scrollbar{width:8px}::-webkit-scrollbar-track{background:#FFF;border-left: 2px solid #222;}::-webkit-scrollbar-thumb{background:#FFD166;border: 2px solid #222;border-radius:4px}
        @keyframes pop-in{from{opacity:0;transform:scale(0.9)}to{opacity:1;transform:scale(1)}}
        @keyframes wiggle{0%,100%{transform:rotate(-3deg)}50%{transform:rotate(3deg)}}
        .page-enter{animation:pop-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards}
        .cham-logo{animation:wiggle 2s ease-in-out infinite; display:inline-block;}
      `}</style>

      <aside style={s.sidebar}>
        <div style={s.logoWrap}>
          <div style={s.logoIconWrap} className="cham-logo">
             <Sparkles size={28} color="#FFF" strokeWidth={3} />
          </div>
          <div>
            <div style={s.logoText}>mono</div>
            <div style={s.logoSub}>DIGITAL MARKETING</div>
          </div>
        </div>

        <div style={s.section}>Overview</div>
        <NavLink to="/dashboard" className={({isActive})=>`nav-link${isActive?' active':''}`}>
          <LayoutDashboard size={20} strokeWidth={2.5} className="nem"/> Dashboard
        </NavLink>

        <div style={s.section}>Engines</div>
        <NavLink to="/attention" className={({isActive})=>`nav-link${isActive?' active':''}`}>
          <Eye size={20} strokeWidth={2.5} className="nem"/> Attention
        </NavLink>
        <div style={s.navDim}><Search size={20} strokeWidth={2.5}/> Intent <span style={s.soon}>soon</span></div>
        <div style={s.navDim}><Rocket size={20} strokeWidth={2.5}/> Acquisition <span style={s.soon}>soon</span></div>
        <div style={s.navDim}><Zap size={20} strokeWidth={2.5}/> Conversion <span style={s.soon}>soon</span></div>
        <div style={s.navDim}><Mail size={20} strokeWidth={2.5}/> Retention <span style={s.soon}>soon</span></div>

        <div style={s.section}>Account</div>
        <NavLink to="/settings" className={({isActive})=>`nav-link${isActive?' active':''}`}>
          <Settings size={20} strokeWidth={2.5} className="nem"/> Settings
        </NavLink>

        <div style={s.userFooter}>
          <div style={s.avatar}>{user?.name?.[0]?.toUpperCase()||'U'}</div>
          <div style={{flex:1,minWidth:0}}>
            <div style={s.uName}>{user?.name}</div>
            <div style={s.uEmail}>{user?.email}</div>
          </div>
          <button onClick={handleLogout} style={s.logoutBtn} title="Sign out">
            <LogOut size={16} strokeWidth={3} />
          </button>
        </div>
      </aside>

      <main style={s.main}><Outlet /></main>
    </div>
  );
}

const s = {
  app:{display:'grid',gridTemplateColumns:'240px 1fr',minHeight:'100vh',fontFamily:'"Nunito",sans-serif',color:'#222'},
  sidebar:{background:'#FFF',borderRight:'3px solid #222',display:'flex',flexDirection:'column'},
  logoWrap:{display:'flex',alignItems:'center',gap:12,padding:'24px',borderBottom:'3px solid #222',marginBottom:16, background:'#FFF9EB'},
  logoIconWrap:{width:46,height:46,borderRadius:12,background:'#FF5C5C',border:'3px solid #222',boxShadow:'2px 2px 0px #222',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0},
  logoText:{fontFamily:'"Fredoka",sans-serif',fontSize:32,fontWeight:700,color:'#222',lineHeight:1,textShadow:'1px 1px 0 #FFD166, 2px 2px 0 #222',letterSpacing:'-0.5px'},
  logoSub:{fontFamily:'"Fredoka",sans-serif',fontSize:9,fontWeight:800,letterSpacing:'0.1em',color:'#FF5C5C',paddingTop:4},
  section:{padding:'12px 24px 6px',fontSize:'12px',fontWeight:800,fontFamily:'"Fredoka",sans-serif',letterSpacing:'0.05em',color:'#AAB1B7',textTransform:'uppercase'},
  navDim:{display:'flex',alignItems:'center',gap:12,padding:'10px 20px',margin:'0 10px 4px 10px',color:'#AAB1B7',fontFamily:'"Fredoka",sans-serif',fontWeight:600,fontSize:15,cursor:'not-allowed'},
  soon:{marginLeft:'auto',fontSize:'10px',fontFamily:'"Fredoka",sans-serif',fontWeight:700,background:'#EEE',border:'2px solid #CCC',color:'#888',padding:'2px 6px',borderRadius:20},
  userFooter:{marginTop:'auto',padding:'16px',borderTop:'3px solid #222',background:'#E8F2FF',display:'flex',alignItems:'center',gap:12},
  avatar:{width:36,height:36,borderRadius:10,background:'#06D6A0',border:'2px solid #222',boxShadow:'2px 2px 0px #222',display:'flex',alignItems:'center',justifyContent:'center',color:'#FFF',fontSize:18,fontWeight:800,fontFamily:'"Fredoka",sans-serif',flexShrink:0},
  uName:{fontSize:14,fontFamily:'"Fredoka",sans-serif',fontWeight:700,color:'#222',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  uEmail:{fontSize:11,fontWeight:600,color:'#666',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  logoutBtn:{background:'#FFF',border:'2px solid #222',boxShadow:'2px 2px 0px #222',color:'#FF5C5C',width:32,height:32,borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'all 0.1s'},
  main:{background:'#F0F4F8',overflowY:'auto'},
};
